var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0509 2.25508C9.41211 2.31985 10.7406 3.00086 11.9999 4.20369C13.2593 3.00086 14.5878 2.31985 15.949 2.25509C17.529 2.17991 18.9648 2.94272 20.1862 4.27948C21.464 5.67785 21.8546 7.24148 21.7269 8.77831C21.602 10.2826 20.984 11.7422 20.2902 13.0076C19.9118 13.6978 19.2195 14.5789 18.4384 15.4799C17.6462 16.3938 16.7228 17.3729 15.8477 18.2689C14.9716 19.1658 14.1386 19.9847 13.5249 20.5791C13.218 20.8764 12.9655 21.1179 12.7896 21.2853C12.7016 21.3689 12.6328 21.4341 12.5858 21.4785L12.532 21.5292L12.513 21.547C12.2255 21.8168 11.7777 21.8174 11.4889 21.549C11.4889 21.549 11.4893 21.5494 11.9999 21L11.4889 21.549L11.4705 21.5318L11.4171 21.482C11.3705 21.4383 11.3022 21.3742 11.215 21.2919C11.0405 21.1272 10.79 20.8895 10.4853 20.5964C9.87613 20.0104 9.04847 19.2016 8.17576 18.3111C7.30399 17.4217 6.38206 16.4456 5.58642 15.5258C4.80089 14.6178 4.10245 13.724 3.70965 13.0076C3.01588 11.7422 2.3979 10.2826 2.27294 8.7783C2.14528 7.24147 2.53586 5.67784 3.81363 4.27947C5.03511 2.94271 6.47087 2.1799 8.0509 2.25508Z",
    fill: "url(#paint0_linear_2541_1718)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2541_1718",
    x1: 2.26401,
    y1: 11.9999,
    x2: 21.7639,
    y2: 11.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D802BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B7DB1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.d306c6b3095d21dff1c46aef7300490f.svg";
export { ForwardRef as ReactComponent };